
import { Vue, Component, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import InvoiceService from '@/services/invoice.service';
import { FormModel } from 'ant-design-vue';

@Component
export default class RejectModal extends Vue {
  visible = false;

  @Ref()
  ruleForm!: FormModel;

  @lazyInject(InvoiceService)
  invoiceService!: InvoiceService;

  title = '驳回';
  width = 500;
  form = {
    remark: '',
    id: '',
  };
  rules = {
    remark: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }],
  };
  labelCol = {
    span: 6,
  };
  wrapperCol = {
    span: 18,
  };
  init(val: any) {
    this.visible = true;
    this.form.id = val.id;
    this.form.remark = '';
  }
  handleCancel() {
    this.visible = false;
  }

  handleOk() {
    this.ruleForm.validate(async (valid) => {
      if (valid) {
        const res = await this.invoiceService.invoiceManageReject(this.form);
        if (res) {
          this.$message.success('操作成功');
          this.$emit('refresh');
          this.visible = false;
        }
      }
    });
  }
}
